<template>
    <div>
        <div class="tree" >
            <el-tree
                    ref="tree"
                    :data="ceshidata"
                    node-key="i_id"
                    :props="defaultProps"
                    @node-click="handleNodeClick"
                    class="trees mrt10 video-tree"
                    default-expand-all
                    :highlight-current='highlighter'
                    :expand-on-click-node="false"
                    :current-node-key="currentNodekey"
                    :show-checkbox="true"
                    :default-checked-keys="defaultTree"
                    @check="check"

                    >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>{{ node.label }}</span>
                </span>
            </el-tree>
            <div slot="footer"  class="dialog-footer" style="text-align: center">
                <el-button type="primary"  :class="baseerp+'btn'"  size="mini" @click="sure">保存</el-button>
                <el-button size="mini" @click="cancel">{{$t('button_cancel')}}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import * as API from "../api"
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    export default {
        name: "chooseEquipment",
        components: {},
        props:{
            equipment:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                defaultTree:[],
                select:[],
                chooselist:"",
                baseerp:"",
                ceshidata:[

                ],
                /***********************/
                i_show:1,
                //nowTime:"",
                //startTime:"",
                //endTime:"",
                highlighter:true,
                currentNodekey:"",
                //openAll:true,
                defaultValue:"",
                checkTimevalue:'',
                addData:[],
                inDex:0,
                mid:0,
                treeExpandData:[],
                expanded:false,
                times:"",
                //highlightCurrentRow:false,
                ID:"",
                iType:0,
                selfPro: [],
                replacePro: [],
                // begin_time: "",
                // end_time: "",
                defaultProps: {
                    children: 'deviceList',
                    label: 'vc_name'
                },
                Node:{},
            }
        },



        mounted() {
            //console.log(this.equipment,"choose_equipment");
            this.select=this.equipment.select;
            //console.log(this.select,"select");
            if (this.select){
                this.defaultTree = this.select.map((item, index, arr) => {
                    //return item.fileid;
                    return item.i_id ;
                });
                //console.log(this.defaultTree, "defaultTree");
            }


            this.baseerp=baseerp;
            //this.getDateMonth();
            this.getDeviceTree();

        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),



            sure(){
                this.$emit('getvalue',this.chooselist);
                this.$emit('close');
            },

            check(data,value){
                //console.log("data",data,"value",value);
                let arr=value.checkedNodes;
                //console.log("arr",arr);
                let arrObjFilter = arr.filter(ele => ele.deviceList == undefined);
                //console.log(arrObjFilter,"arrObjFilter");
                this.chooselist=arrObjFilter;
            },

            cancel(){
              this.$emit('close')
            },


            handleNodeClick(data, node, it) {
                //console.log(data, node, "tree当前行");
                this.Node=node;
                this.highlighter=true;
                this.iType=data.i_type;
                //this.inDex=data.i_id;
                //console.log(data.i_id,"inDex");
                if (node.childNodes.length==0&&data.i_name!=null){
                    //console.log("length");
                    if (data.i_name=='上级1'){
                        this.inDex=data.i_id;
                        //this.inDex=0;
                        this.getScorderList();
                        let addData = {
                            i_id: 0,
                            i_type:0,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(addData,"111zzzzzzz");
                        this.$emit('getValue', addData)
                    }else if(data.i_name=='上级2'){
                        this.inDex=data.i_id;
                        //this.inDex=1;
                        this.getScorderList();
                        let addData = {
                            i_id: 0,
                            i_type:1,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(addData,"1111sssssssssssss");
                        this.$emit('getValue', addData)
                    }
                }else{
                    //this.getScorderList();
                    if (data.i_name=='上级1'){
                        this.inDex=0;
                        /*console.log(this.checkTimevalue,this.defaultValue,"66666");
                        if (this.checkTimevalue>this.defaultValue){
                            this.i_show=0
                        }else{
                            this.i_show=1
                        }*/
                        let addData = {
                            i_id: 0,
                            i_type:0,
                            i_mid:this.mid,
                            i_show:this.i_show,
                            //checkTimevalue:this.checkTimevalue,
                            //defaultValue:this.defaultValue,
                        };
                        //console.log(addData,"上级1zzzzzzz");
                        this.$emit('getValue', addData)
                    }else if(data.i_name=='上级2'){
                        this.inDex=1;
                        /*console.log(this.checkTimevalue,this.defaultValue,"77777");
                        if (this.checkTimevalue>this.defaultValue){
                            this.i_show=0
                        }else{
                            this.i_show=1
                        }*/
                        let addData = {
                            i_id: 0,
                            i_type:1,
                            i_mid:this.mid,
                            i_show:this.i_show,
                            //checkTimevalue:this.checkTimevalue,
                            //defaultValue:this.defaultValue,
                        };
                        //console.log(addData,"上级2sssssssssssss");
                        this.$emit('getValue', addData)
                    }else if (data.i_name==null){
                        this.ID=data.i_id;
                        this.iType=data.i_type;
                        this.inDex=data.i_type;
                        let watchData = {
                            value: data,
                            title: "查看",
                            i_id:this.ID,
                            i_type:this.iType,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(watchData,"watchData");
                        this.$emit('getValue', watchData)
                    }
                }
            },



            //tree接口
            async getDeviceTree() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getDeviceTree(param);
                if (res.code == 1) {
                    this.ceshidata=res.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },



            //获取当月日期
            getDateMonth(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                //const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.defaultValue=`${date.getFullYear()}-${month}`;
                this.checkTimevalue=`${date.getFullYear()}-${month}`;
                //console.log(this.checkTimevalue,"timeee",this.defaultValue);
                //console.log(this.checkTimevalue,"checkTimevalue")
            },
        }
    }
</script>

<style lang="scss" scoped>

    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }
        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    .el-tree {

    }
    /* .tree {
         overflow: auto;
         height: calc(90vh - 80px)
     }*/

    .flex{
        justify-content: left;
    }

    .mrt10{
        margin-top: 10px;
    }
    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width:260px;
    }

    /deep/ {
        .el-tree-node__expand-icon{
            color: black;
        }

        .el-tree-node__expand-icon.is-leaf {
            color: transparent;
            cursor: default;
        }
        .el-tree-node__label {
            font-size: 17px;
        }

    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
    /*
        @media screen and (max-height: 770px) {
            .video-tree {
                //width: 420px;
                height: 530px;
            }
        }
        @media screen and (min-height: 900px) {
            .video-tree {
                //width: 530px;
                height: 685px;
            }
        }
        @media screen and (min-height: 780px) and (max-height: 830px) {
            .video-tree {
                //width: 450px;
                height: 610px;
            }
        }*/

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
        max-height: calc(80vh);
        min-height: calc(40vh);
    }


</style>